/**
 * extend-core-list.js
 */

/* global wp */
const { addFilter } = wp.hooks;
const { createHigherOrderComponent } = wp.compose;
const { InspectorControls } = wp.blockEditor || wp.editor; // fallback for older WP
const { PanelBody, SelectControl } = wp.components;
const { __ } = wp.i18n;

console.log('Extend-core-list.js loaded...');

/**
 * 1) Add a `customListClass` attribute to the core List block.
 */
function addCustomListAttributes(settings, name) {
  if (name !== 'core/list') {
    return settings;
  }

  settings.attributes = {
    ...settings.attributes,
    customListClass: {
      type: 'string',
      default: '',
    },
  };

  return settings;
}
addFilter(
  'blocks.registerBlockType',
  'my-plugin/core-list/add-custom-attributes',
  addCustomListAttributes
);

/**
 * 2) Create a higher-order component that injects
 *    a control in the Inspector for `core/list`.
 */
const withCustomListControls = createHigherOrderComponent((BlockEdit) => {
  return (props) => {
    const { name, attributes, setAttributes, isSelected } = props;
    const { customListClass } = attributes;
    if (name !== 'core/list') {
      return <BlockEdit {...props} />;
    }

    console.log(props);

    return (
      <>
        <BlockEdit {...props} />
        {
          <InspectorControls>
            <PanelBody title={__('Custom List Style', 'my-plugin')}>
              <SelectControl
                label={__('Choose a List Style', 'my-plugin')}
                value={customListClass}
                options={[
                  { label: 'Alpha', value: 'alpha' },
                  { label: 'Numeric', value: 'numeric' },
                  { label: 'Disc', value: 'disc' },
                  { label: 'Checklist', value: 'checklist' },
                ]}
                onChange={(selectedClass) =>
                  setAttributes({ customListClass: selectedClass })
                }
              />
            </PanelBody>
          </InspectorControls>
        }
      </>
    );
  };
}, 'withCustomListControls');

addFilter(
  'editor.BlockEdit',
  'my-plugin/core-list/with-custom-list-controls',
  withCustomListControls
);

/**
 * 3) Append the `customListClass` to the front-end markup.
 */
function applyCustomListExtraProps(saveElementProps, blockType, attributes) {
  if (blockType.name !== 'core/list') {
    return saveElementProps;
  }

  const { customListClass } = attributes;

  if (customListClass) {
    saveElementProps.className = [
      saveElementProps.className,
      `pg-list pg-list--${customListClass}`,
    ]
      .filter(Boolean)
      .join(' ');
  }

  return saveElementProps;
}
addFilter(
  'blocks.getSaveContent.extraProps',
  'my-plugin/core-list/apply-custom-list-extra-props',
  applyCustomListExtraProps
);

function addEditorListClass(BlockListBlock) {
  return (props) => {
    if (props.block.name !== 'core/list') {
      return <BlockListBlock {...props} />;
    }
    const { customListClass } = props.block.attributes;

    const newProps = {
      ...props,
      className: [props.className, `pg-list pg-list--${customListClass}`]
        .filter(Boolean)
        .join(' '),
    };
    return <BlockListBlock {...newProps} />;
  };
}
addFilter(
  'editor.BlockListBlock',
  'my-plugin/core-list/add-editor-list-class',
  addEditorListClass
);
